export default __webpack_public_path__ + "static/media/ten.ea060b52.svg";